/* =========================================================
   CHELSY HAIR — thème Shopify
   · Navigation fluide : les pages s'enchaînent sans rechargement,
     la musique ne s'arrête jamais.
   · Lecteur de musique (playlist de 10 morceaux, sur tout le site).
   · Salon des langues (FR / EN / ES) animé.
   · Panier AJAX, fiche produit, réservation, intro rideau, politiques.
   ========================================================= */
(function () {
  'use strict';

  const I = {
    fleche: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>',
    coche: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>',
    lecture: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5.5v13l11-6.5z"/></svg>',
    pause: '<svg viewBox="0 0 24 24" fill="currentColor"><rect x="6.5" y="5" width="4" height="14" rx="1"/><rect x="13.5" y="5" width="4" height="14" rx="1"/></svg>',
    precedent: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M7 6h2v12H7zM20 6v12l-9-6z"/></svg>',
    suivant: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M15 6h2v12h-2zM4 6v12l9-6z"/></svg>',
    volume: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M4 9.5h3.5L12 6v12l-4.5-3.5H4z" fill="currentColor" stroke="none"/><path d="M15.5 9a4 4 0 0 1 0 6M18 6.5a7.5 7.5 0 0 1 0 11"/></svg>',
    croix: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M6 6l12 12M18 6 6 18"/></svg>'
  };
  const C = () => window.CHELSY || {};
  const txt = (k, defaut) => (C().textes && C().textes[k]) || defaut || '';
  const lire = (cle, defaut) => { try { return JSON.parse(sessionStorage.getItem(cle)) ?? defaut; } catch (e) { return defaut; } };
  const ecrire = (cle, v) => { try { sessionStorage.setItem(cle, JSON.stringify(v)); } catch (e) { /* stockage indisponible */ } };
  const attendre = ms => new Promise(r => setTimeout(r, ms));
  const reduit = matchMedia('(prefers-reduced-motion: reduce)').matches;
  let nettoyages = []; // fonctions appelées avant de quitter une page (observateurs, minuteurs…)

  /* ---------- notification ---------- */
  let minuteurToast;
  function toast(msg) {
    const t = document.getElementById('toast'); if (!t) return;
    t.textContent = msg; t.classList.add('visible');
    clearTimeout(minuteurToast); minuteurToast = setTimeout(() => t.classList.remove('visible'), 2600);
  }

  /* =========================================================
     ÉCOUTEURS GLOBAUX (posés une seule fois, valables sur toutes les pages)
     ========================================================= */
  addEventListener('scroll', () => {
    const barre = document.getElementById('barre'); if (barre) barre.classList.toggle('ombre', scrollY > 10);
  }, { passive: true });

  document.addEventListener('click', e => {
    // menu mobile
    if (e.target.closest('[data-menu]')) {
      const m = document.getElementById('menuMobile');
      const o = m.classList.toggle('ouvert');
      m.setAttribute('aria-hidden', !o);
      document.body.style.overflow = o ? 'hidden' : '';
    }
    // filtres (produits par étiquette / résultats par catégorie)
    const f = e.target.closest('[data-filtres] .filtre');
    if (f) {
      const groupe = f.closest('[data-filtres]'), cible = document.querySelector(groupe.dataset.filtres);
      groupe.querySelectorAll('.filtre').forEach(x => x.classList.toggle('actif', x === f));
      cible.querySelectorAll('[data-cat]').forEach(c => c.classList.toggle('cache', f.dataset.f !== 'tous' && !c.dataset.cat.split(' ').includes(f.dataset.f)));
    }
    if (e.target.closest('[data-haut]')) { e.preventDefault(); scrollTo({ top: 0, behavior: 'smooth' }); }
  });
  document.addEventListener('shopify:section:load', e => { e.target.querySelectorAll('.revele').forEach(el => el.classList.add('vu')); initialise(e.target); });

  /* =========================================================
     VISUELS PRODUITS DE SECOURS (flacons dessinés en SVG)
     ========================================================= */
  function flacon(type, teinte, nom) {
    const u = Math.random().toString(36).slice(2, 8);
    const etiquette = `<rect x="R_X" y="R_Y" width="R_W" height="R_H" rx="4" fill="#f7efe1"/><text x="50" y="T_Y" text-anchor="middle" font-family="Pinyon Script, cursive" font-size="F_S" fill="#a57d3a">Chelsy</text><text x="50" y="T2_Y" text-anchor="middle" font-family="Montserrat, sans-serif" font-size="4.2" letter-spacing="1" fill="#6f6157">${nom}</text>`;
    const or = `<linearGradient id="go${u}" x1="0" x2="1"><stop offset="0" stop-color="#9f7432"/><stop offset=".5" stop-color="#f1d899"/><stop offset="1" stop-color="#9f7432"/></linearGradient>`;
    const verre = `<linearGradient id="gv${u}" x1="0" x2="1"><stop offset="0" stop-color="${teinte}" stop-opacity=".95"/><stop offset=".35" stop-color="#fff" stop-opacity=".35"/><stop offset=".5" stop-color="${teinte}" stop-opacity=".9"/><stop offset="1" stop-color="#000" stop-opacity=".55"/></linearGradient>`;
    if (type === 'pipette') return `<svg viewBox="0 0 100 200"><defs>${or}${verre}</defs><rect x="43" y="6" width="14" height="30" rx="7" fill="#1b1410"/><rect x="38" y="34" width="24" height="22" rx="3" fill="url(#go${u})"/><rect x="22" y="56" width="56" height="134" rx="12" fill="url(#gv${u})"/>${etiquette.replace('R_X', 28).replace('R_Y', 96).replace('R_W', 44).replace('R_H', 56).replace('T_Y', 124).replace('F_S', 16).replace('T2_Y', 140)}</svg>`;
    if (type === 'pompe') return `<svg viewBox="0 0 100 200"><defs>${or}${verre}</defs><path d="M50 6h20v8H56v14h-12V14Z" fill="#1b1410"/><rect x="40" y="26" width="20" height="16" rx="2" fill="url(#go${u})"/><rect x="26" y="42" width="48" height="150" rx="16" fill="url(#gv${u})"/>${etiquette.replace('R_X', 31).replace('R_Y', 92).replace('R_W', 38).replace('R_H', 60).replace('T_Y', 121).replace('F_S', 14).replace('T2_Y', 138)}</svg>`;
    if (type === 'pot') return `<svg viewBox="0 0 120 120"><defs>${or}${verre}</defs><rect x="14" y="20" width="92" height="22" rx="6" fill="url(#go${u})"/><rect x="10" y="40" width="100" height="72" rx="14" fill="url(#gv${u})"/>${etiquette.replace('R_X', 26).replace('R_Y', 54).replace('R_W', 68).replace('R_H', 44).replace(/x="50"/g, 'x="60"').replace('T_Y', 78).replace('F_S', 16).replace('T2_Y', 92)}</svg>`;
    return `<svg viewBox="0 0 240 200">${flacon('pompe', teinte, '').replace('<svg viewBox="0 0 100 200">', '<g transform="translate(0,18) scale(.9)">').replace('</svg>', '</g>')}${flacon('pipette', '#6b2f12', '').replace('<svg viewBox="0 0 100 200">', '<g transform="translate(70,0)">').replace('</svg>', '</g>')}${flacon('pot', '#2a1a10', '').replace('<svg viewBox="0 0 120 120">', '<g transform="translate(150,96) scale(.8)">').replace('</svg>', '</g>')}</svg>`;
  }

  /* =========================================================
     PANIER — API AJAX Shopify (/cart.js, /cart/add.js, /cart/change.js)
     ========================================================= */
  const url = chemin => ((C().routes && C().routes.root) || '/').replace(/\/$/, '') + chemin;
  const argent = (centimes, devise) => new Intl.NumberFormat(document.documentElement.lang || 'fr', { style: 'currency', currency: devise || C().devise || 'EUR' }).format(centimes / 100);
  const tiroir = () => document.getElementById('tiroir');

  function ouvrePanier(o) {
    const t = tiroir();
    if (!t) { if (o) location.href = url('/cart'); return; }
    t.classList.toggle('ouvert', o); document.getElementById('voile').classList.toggle('visible', o);
    t.setAttribute('aria-hidden', !o);
  }
  function rendPanier(c) {
    document.querySelectorAll('.pastille-panier').forEach(p => { p.textContent = c.item_count; p.classList.toggle('visible', c.item_count > 0); });
    const t = tiroir(); if (!t) return;
    t.querySelector('.lignes').innerHTML = c.items.length ? c.items.map(l => `
      <div class="ligne" data-cle="${l.key}">
        ${l.image ? `<img src="${l.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2')}" alt="" loading="lazy">` : '<span class="vignette"></span>'}
        <div class="detail"><a href="${l.url}"><b>${l.product_title}</b></a>${l.variant_title ? `<small>${l.variant_title}</small>` : ''}
          <span class="mini-qte"><button type="button" data-qte="${l.quantity - 1}" aria-label="−">−</button><span>${l.quantity}</span><button type="button" data-qte="${l.quantity + 1}" aria-label="+">+</button></span></div>
        <b>${argent(l.final_line_price, c.currency)}</b>
      </div>`).join('') : `<p class="texte-doux" style="padding:20px 0">${txt('panierVide', 'Votre panier est vide.')}</p>`;
    t.querySelector('.total-montant').textContent = argent(c.total_price, c.currency);
    t.querySelector('.btn-commander').toggleAttribute('disabled', !c.item_count);
  }
  async function chargePanier() {
    const r = await fetch(url('/cart.js'), { headers: { Accept: 'application/json' } });
    const c = await r.json(); rendPanier(c); return c;
  }
  async function ajoute(donnees) {
    const r = await fetch(url('/cart/add.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(donnees) });
    const res = await r.json();
    if (!r.ok) throw new Error(res.description || res.message || 'Erreur');
    await chargePanier(); return res;
  }
  document.addEventListener('submit', async e => {
    const f = e.target.closest('form[data-ajout-panier]'); if (!f) return;
    e.preventDefault();
    const bouton = f.querySelector('[type="submit"]'); bouton && bouton.setAttribute('disabled', '');
    try {
      const fd = new FormData(f);
      await ajoute({ items: [{ id: +fd.get('id'), quantity: +(fd.get('quantity') || 1) }] });
      ouvrePanier(true);
    } catch (err) { toast(err.message); }
    finally { bouton && bouton.removeAttribute('disabled'); }
  });
  document.addEventListener('click', async e => {
    if (e.target.closest('[data-ouvre-panier]')) { e.preventDefault(); ouvrePanier(true); chargePanier(); }
    if (e.target.closest('[data-ferme-panier]') || e.target.id === 'voile') ouvrePanier(false);
    const q = e.target.closest('.tiroir [data-qte]');
    if (q) {
      const t = tiroir(); t.classList.add('charge');
      try {
        const r = await fetch(url('/cart/change.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: q.closest('.ligne').dataset.cle, quantity: +q.dataset.qte }) });
        const c = await r.json();
        if (!r.ok) toast(c.description || c.message); else rendPanier(c);
      } finally { t.classList.remove('charge'); }
    }
  });
  addEventListener('keydown', e => { if (e.key === 'Escape') { ouvrePanier(false); Langues.ferme(); Lecteur.fermePanneau(); } });

  /* =========================================================
     INITIALISATION D'UNE PAGE (au chargement et après chaque navigation fluide)
     ========================================================= */
  function initialise(racine) {
    racine = racine || document;

    // icônes déclarées dans le HTML (data-i="fleche")
    racine.querySelectorAll('[data-i]').forEach(el => { if (!el.firstChild) el.innerHTML = I[el.dataset.i] || ''; });

    // apparitions au défilement
    const obs = new IntersectionObserver(entrees => entrees.forEach(en => {
      if (en.isIntersecting) { en.target.classList.add('vu'); obs.unobserve(en.target); }
    }), { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    racine.querySelectorAll('.revele:not(.vu)').forEach(el => obs.observe(el));
    nettoyages.push(() => obs.disconnect());

    // flacons de secours
    racine.querySelectorAll('[data-flacon]:not([data-fait])').forEach(el => {
      el.dataset.fait = '1';
      el.insertAdjacentHTML('afterbegin', flacon(el.dataset.flacon, el.dataset.teinte || '#5b2b12', el.dataset.nom || ''));
    });

    // liens internes : on garde la langue choisie (/en/…, /es/…)
    localiseLiens(racine);
    initFicheProduit(racine);
    initReservation(racine);
    initIntro(racine);
    initPolitique(racine);
    racine.querySelectorAll('[data-lecteur-bascule]').forEach(b => b.addEventListener('click', () => Lecteur.bascule()));
    const barre = document.getElementById('barre'); if (barre) barre.classList.toggle('ombre', scrollY > 10);
  }

  function localiseLiens(racine) {
    const prefixe = C().racine || '';
    if (!prefixe) return;
    racine.querySelectorAll('a[href^="/"]').forEach(a => {
      const h = a.getAttribute('href');
      if (h.startsWith('//') || h === prefixe || h.startsWith(prefixe + '/') || /^\/(cdn|checkout|account|apps|services|s\/files|admin)(\/|$)/.test(h)) return;
      a.setAttribute('href', prefixe + (h === '/' ? '' : h));
    });
  }

  /* ---------- fiche produit : quantité, variantes, galerie ---------- */
  function initFicheProduit(racine) {
    racine.querySelectorAll('[data-fiche-produit]').forEach(fiche => {
      const variantes = JSON.parse(fiche.querySelector('[data-variantes]').textContent);
      const sel = fiche.querySelector('select[name="id"]'), prix = fiche.querySelector('.prix-produit'), bouton = fiche.querySelector('[type="submit"]');
      fiche.addEventListener('click', e => {
        const m = e.target.closest('[data-pas]');
        if (m) { const i = fiche.querySelector('input[name="quantity"]'); i.value = Math.max(1, +i.value + +m.dataset.pas); }
        const v = e.target.closest('.miniatures button');
        if (v) { fiche.querySelector('.principale img').src = v.dataset.grande; fiche.querySelectorAll('.miniatures button').forEach(x => x.classList.toggle('actif', x === v)); }
      });
      if (sel) sel.addEventListener('change', () => {
        const v = variantes.find(x => x.id === +sel.value); if (!v) return;
        prix.innerHTML = argent(v.price) + (v.compare_at_price > v.price ? ` <s>${argent(v.compare_at_price)}</s>` : '');
        bouton.toggleAttribute('disabled', !v.available);
        bouton.querySelector('.texte').textContent = v.available ? txt('ajouter') : txt('epuise');
        if (v.featured_image) fiche.querySelector('.principale img').src = v.featured_image.src;
        history.replaceState(history.state, '', `?variant=${v.id}`);
      });
    });
  }

  /* ---------- réservation (version formulaire Shopify) ---------- */
  function initReservation(racine) {
    const resa = racine.querySelector('[data-reservation]');
    if (!resa || !resa.querySelector('.calendrier')) return;
    const etat = { soin: null, prix: null, date: null, heure: null };
    const pas = [...resa.querySelectorAll('.pas:not(.confirmation)')];
    const pts = [...resa.querySelectorAll('.fil-etapes .pt')], traits = [...resa.querySelectorAll('.fil-etapes .trait')];
    const joursOuverts = (resa.dataset.jours || '2,3,4,5,6').split(',').map(Number);
    const heuresSemaine = (resa.dataset.heures || '').split(',').map(s => s.trim()).filter(Boolean);
    const heuresSamedi = (resa.dataset.heuresSamedi || '').split(',').map(s => s.trim()).filter(Boolean);
    const nbMois = +(resa.dataset.mois || 2);
    const loc = document.documentElement.lang || 'fr';
    const dateLongue = d => d.toLocaleDateString(loc, { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
    let courant = 0;
    function aller(i) {
      courant = i;
      pas.forEach((p, k) => p.classList.toggle('on', k === i));
      pts.forEach((p, k) => { p.classList.toggle('fait', k < i); p.classList.toggle('encours', k === i); });
      traits.forEach((t, k) => t.classList.toggle('fait', k < i));
      if (i === 3) {
        resa.querySelector('.recap').innerHTML = `<span><b>${etat.soin}</b> — ${etat.prix}</span><span><b>${dateLongue(etat.date)}</b> · <b>${etat.heure}</b></span>`;
        resa.querySelector('[name="contact[Soin]"]').value = `${etat.soin} (${etat.prix})`;
        resa.querySelector('[name="contact[Date]"]').value = dateLongue(etat.date);
        resa.querySelector('[name="contact[Heure]"]').value = etat.heure;
      }
      resa.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    resa.addEventListener('click', e => {
      const s = e.target.closest('.choix-soin');
      if (s) { resa.querySelectorAll('.choix-soin').forEach(x => x.classList.remove('choisi')); s.classList.add('choisi'); etat.soin = s.dataset.soin; etat.prix = s.dataset.prix; setTimeout(() => aller(1), 280); }
      if (e.target.closest('[data-retour]')) aller(courant - 1);
    });
    const param = new URLSearchParams(location.search).get('soin');
    if (param) { const s = [...resa.querySelectorAll('.choix-soin')].find(x => x.dataset.cle === param); if (s) s.classList.add('choisi'); }
    const cal = resa.querySelector('.calendrier');
    const auj = new Date(); auj.setHours(0, 0, 0, 0);
    const max = new Date(auj.getFullYear(), auj.getMonth() + nbMois, 0);
    const vue = new Date(auj.getFullYear(), auj.getMonth(), 1);
    const nomsJours = [...Array(7)].map((_, k) => new Intl.DateTimeFormat(loc, { weekday: 'narrow' }).format(new Date(2024, 0, 1 + k)));
    function dessineCal() {
      const an = vue.getFullYear(), mo = vue.getMonth();
      const premier = (new Date(an, mo, 1).getDay() + 6) % 7, nb = new Date(an, mo + 1, 0).getDate();
      let h = `<div class="mois"><button type="button" data-m="-1" ${vue <= new Date(auj.getFullYear(), auj.getMonth(), 1) ? 'disabled' : ''} aria-label="‹">‹</button><span>${vue.toLocaleDateString(loc, { month: 'long', year: 'numeric' })}</span><button type="button" data-m="1" ${new Date(an, mo + 1, 1) > max ? 'disabled' : ''} aria-label="›">›</button></div><div class="jours">`;
      h += nomsJours.map(j => `<span class="nom-jour">${j}</span>`).join('') + '<span></span>'.repeat(premier);
      for (let d = 1; d <= nb; d++) {
        const dt = new Date(an, mo, d);
        const ok = dt > auj && dt <= max && joursOuverts.includes(dt.getDay());
        const choisi = etat.date && dt.getTime() === etat.date.getTime();
        h += `<button type="button" ${ok ? `class="dispo${choisi ? ' choisi' : ''}" data-j="${dt.getTime()}"` : 'disabled'}>${d}</button>`;
      }
      cal.innerHTML = h + '</div>';
    }
    cal.addEventListener('click', e => {
      const m = e.target.closest('[data-m]'); if (m) { vue.setMonth(vue.getMonth() + +m.dataset.m); dessineCal(); return; }
      const j = e.target.closest('[data-j]'); if (!j) return;
      etat.date = new Date(+j.dataset.j); dessineCal();
      const heures = etat.date.getDay() === 6 && heuresSamedi.length ? heuresSamedi : heuresSemaine;
      resa.querySelector('.creneaux').innerHTML = heures.map(x => `<button type="button" data-h="${x}">${x}</button>`).join('');
      resa.querySelector('.jour-choisi').textContent = dateLongue(etat.date);
      setTimeout(() => aller(2), 280);
    });
    resa.querySelector('.creneaux').addEventListener('click', e => {
      const b = e.target.closest('[data-h]'); if (!b) return;
      resa.querySelectorAll('.creneaux button').forEach(x => x.classList.toggle('choisi', x === b));
      etat.heure = b.dataset.h; setTimeout(() => aller(3), 280);
    });
    dessineCal();
  }

  /* ---------- intro rideau : à chaque nouvelle visite ----------
     Le rideau s'affiche à l'ouverture du site (nouvel onglet ou nouvelle fenêtre).
     Pendant la visite (changement de page, retour à l'accueil, rechargement), il ne revient pas.
     Quand on choisit une langue sur le rideau, il se referme puis se rouvre dans la nouvelle langue. */
  function introAutorisee() {
    if (lire('chelsyIntroLangue', false)) { ecrire('chelsyIntroLangue', false); return true; }
    return !lire('chelsyIntro', false);
  }

  /* ---------- intro rideau ---------- */
  function initIntro(racine) {
    const intro = racine.querySelector('#introRideau');
    if (!intro) return;
    if (!C().editeur && !introAutorisee()) { intro.remove(); return; }
    intro.hidden = false; document.documentElement.classList.add('intro-active');
    // retour d'un changement de langue : les rideaux arrivent fermés puis se rouvrent sur la scène
    if (lire('chelsyIntroFerme', false)) {
      ecrire('chelsyIntroFerme', false);
      intro.classList.add('entree', 'sans-transition');
      requestAnimationFrame(() => { intro.classList.remove('sans-transition'); setTimeout(() => intro.classList.remove('entree'), 250); });
    }
    const fermer = anime => {
      ecrire('chelsyIntro', true);
      const fin = () => { intro.remove(); document.documentElement.classList.remove('intro-active'); };
      if (!anime) return fin();
      intro.classList.add('entree');
      setTimeout(() => { intro.classList.remove('entree'); intro.classList.add('sortie'); document.documentElement.classList.remove('intro-active'); }, 900);
      setTimeout(fin, 3300);
    };
    intro.querySelector('.btn-entrer').addEventListener('click', e => { e.preventDefault(); Lecteur.demarre(); fermer(true); });
    intro.querySelector('.passer').addEventListener('click', () => fermer(false));
    const bm = intro.querySelector('.musique');
    if (bm) { if (!Lecteur.actif) bm.remove(); else Lecteur.relie(bm); }
  }

  /* ---------- pages de politiques : sommaire, numéros dorés, lettrine, progression ---------- */
  let progressionPolitique = null;
  addEventListener('scroll', () => progressionPolitique && progressionPolitique(), { passive: true });
  function initPolitique(racine) {
    progressionPolitique = null;
    const carte = racine.querySelector('#politiqueCarte');
    const texte = carte && carte.querySelector('.shopify-policy__body .rte');
    if (!texte) return;
    const titre = (racine.querySelector('.politique-heros__titre') || {}).textContent || '';
    const simplifie = s => s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
    const premier = texte.querySelector(':scope > :is(h1, h2, h3)');
    if (premier && premier === texte.firstElementChild && simplifie(premier.textContent).includes(simplifie(titre).split(' ').slice(0, 2).join(' '))) premier.classList.add('doublon');
    const maj = [...texte.querySelectorAll(':scope > p')].slice(0, 4).find(p => /derni[eè]re mise [aà] jour|mis[e]? [aà] jour le|last updated|[uú]ltima actualizaci[oó]n/i.test(p.textContent));
    if (maj) { const c = racine.querySelector('.politique-maj'); c.textContent = maj.textContent.replace(/\s+/g, ' ').trim(); c.hidden = false; maj.classList.add('doublon'); }
    const mots = texte.textContent.trim().split(/\s+/).length;
    const lecture = racine.querySelector('.politique-lecture');
    lecture.textContent = txt('lecture', 'Lecture : %n min').replace('%n', Math.max(1, Math.round(mots / 220))); lecture.hidden = false;
    texte.querySelectorAll('h1, h2, h3, h4, h5').forEach(h => { if (/^\s*([\dIVX]+\s*[.)\-–—:]?)?\s*$/.test(h.textContent)) h.classList.add('doublon'); });
    const visibles = sel => [...texte.querySelectorAll(sel)].filter(h => !h.classList.contains('doublon'));
    const niveau = ['h2', 'h3', 'h4'].find(n => visibles(n).length >= 2) || 'h2';
    const sousNiveau = { h2: 'h3', h3: 'h4', h4: 'h5' }[niveau];
    const sommaire = racine.querySelector('#politiqueSommaire');
    const sections = visibles(niveau);
    sections.forEach((h, i) => {
      const brut = h.textContent.replace(/\s+/g, ' ').trim();
      const m = brut.match(/^(\d+|[IVX]+)\s*[.)\-–—:]\s*(.+)$/);
      const num = String(i + 1);
      const libelle = (m ? m[2] : brut).replace(/</g, '&lt;');
      h.id = h.id || 'section-' + (i + 1);
      h.classList.add('titre-section-pol');
      h.innerHTML = `<span class="num">${num.padStart(2, '0')}</span><span>${libelle}</span>`;
      sommaire.insertAdjacentHTML('beforeend', `<li><a href="#${h.id}"><b>${num}</b><span>${libelle}</span></a></li>`);
    });
    visibles(sousNiveau).forEach(h => h.classList.add('sous-titre-pol'));
    if (!sections.length) racine.querySelector('.politique__sommaire').remove();
    const intro = [...texte.querySelectorAll(':scope > p')].find(p => !p.classList.contains('doublon') && p.textContent.trim().length > 90 && !/^\s*<strong>/i.test(p.innerHTML));
    if (intro) intro.classList.add('lettrine');
    const liens = [...sommaire.querySelectorAll('a')];
    const suivi = new IntersectionObserver(entrees => entrees.forEach(en => {
      if (en.isIntersecting) liens.forEach(a => a.classList.toggle('actif', a.getAttribute('href') === '#' + en.target.id));
    }), { rootMargin: '-20% 0px -70% 0px' });
    sections.forEach(h => suivi.observe(h));
    nettoyages.push(() => suivi.disconnect());
    const barre = racine.querySelector('.politique-progression span');
    progressionPolitique = () => {
      const r = carte.getBoundingClientRect(), total = r.height - innerHeight * .6;
      barre.style.width = Math.min(100, Math.max(0, (-r.top + 120) / total * 100)) + '%';
    };
    progressionPolitique();
    if (innerWidth < 1020 && sections.length) sommaire.closest('details').open = false;
    sommaire.addEventListener('click', e => {
      const a = e.target.closest('a'); if (!a) return;
      e.preventDefault(); document.querySelector(a.getAttribute('href')).scrollIntoView({ behavior: 'smooth' });
      if (innerWidth < 1020) sommaire.closest('details').open = false;
    });
  }

  /* =========================================================
     NAVIGATION FLUIDE
     La page suivante est chargée en arrière-plan puis remplace #page :
     le lecteur de musique, placé en dehors, continue sans coupure.
     ========================================================= */
  const Navigation = (() => {
    const exclu = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(checkout|account|apps|services|challenge|password|admin|cdn|tools)(\/|$)/i;
    let enCours = false;

    function lienCompatible(a, e) {
      if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return false;
      if (a.target && a.target !== '_self') return false;
      if (a.hasAttribute('download') || a.dataset.rechargement !== undefined || a.closest('[data-rechargement]')) return false;
      const u = new URL(a.href, location.href);
      if (u.origin !== location.origin) return false;
      if (exclu.test(u.pathname) || /\.(pdf|jpe?g|png|webp|gif|mp3|mp4|zip|xml|json|js)$/i.test(u.pathname)) return false;
      if (u.pathname === location.pathname && u.search === location.search && u.hash) return false; // ancre sur la même page
      return true;
    }

    async function charge(cible, { pousse = true, mode = 'page', salut = '' } = {}) {
      if (enCours) return; enCours = true;
      const voile = document.getElementById('voilePage');
      const debut = Date.now();
      if (mode === 'page') { voile.className = 'voile-page actif'; }
      try {
        const r = await fetch(cible, { headers: { Accept: 'text/html' }, credentials: 'same-origin' });
        const type = r.headers.get('content-type') || '';
        if (!r.ok && r.status !== 404 || !type.includes('text/html')) throw new Error('page');
        const html = await r.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const nouvelle = doc.getElementById('page');
        if (!nouvelle) throw new Error('page');
        if (mode === 'page') await attendre(Math.max(0, 380 - (Date.now() - debut)));

        // nouvelle configuration (langue, textes) et nouvelle page
        nettoyages.forEach(f => { try { f(); } catch (e) { /* ignore */ } }); nettoyages = [];
        const conf = [...doc.querySelectorAll('script')].find(s => s.textContent.includes('window.CHELSY ='));
        if (conf) { try { new Function(conf.textContent)(); } catch (e) { /* ignore */ } }
        document.title = doc.title;
        document.documentElement.lang = doc.documentElement.lang;
        const desc = doc.querySelector('meta[name="description"]'), descActuelle = document.querySelector('meta[name="description"]');
        if (desc && descActuelle) descActuelle.content = desc.content;
        document.body.dataset.template = nouvelle.dataset.template || '';
        document.body.style.overflow = '';
        const page = document.getElementById('page');
        page.replaceWith(document.importNode(nouvelle, true));
        executeScripts(document.getElementById('page'));
        const finale = new URL(r.url || cible, location.href);
        const adresse = finale.pathname + finale.search + new URL(cible, location.href).hash;
        if (pousse) history.pushState({ chelsy: true }, '', adresse);
        const ancre = location.hash && document.getElementById(decodeURIComponent(location.hash.slice(1)));
        if (ancre) ancre.scrollIntoView(); else scrollTo(0, 0);
        initialise(document.getElementById('page'));
        Lecteur.majTextes();
        chargePanier().catch(() => {});
        document.dispatchEvent(new CustomEvent('chelsy:page'));
        if (window.ShopifyAnalytics && ShopifyAnalytics.lib && ShopifyAnalytics.lib.page) { try { ShopifyAnalytics.lib.page(); } catch (e) { /* ignore */ } }

        // lever de rideau
        if (mode === 'langue') { voile.classList.add('sort-etoile'); await attendre(1100); }
        else if (mode === 'page') { voile.classList.add('sort'); await attendre(450); }
        voile.className = 'voile-page';
        voile.querySelectorAll('.voile-page__salut, .moitie').forEach(x => x.remove());
      } catch (err) {
        location.href = cible; // repli : chargement classique
      } finally { enCours = false; }
    }

    function executeScripts(racine) {
      racine.querySelectorAll('script').forEach(ancien => {
        if (ancien.type && !/javascript|module/.test(ancien.type)) return; // JSON, modèles…
        const s = document.createElement('script');
        [...ancien.attributes].forEach(a => s.setAttribute(a.name, a.value));
        s.textContent = ancien.textContent;
        ancien.replaceWith(s);
      });
    }

    function active() {
      if (C().editeur || !window.fetch || !window.DOMParser) return;
      history.replaceState({ chelsy: true }, '', location.href);
      document.addEventListener('click', e => {
        const a = e.target.closest('a[href]');
        if (!lienCompatible(a, e)) return;
        if (a.closest('#tiroir') && !a.classList.contains('retour')) return; // liens produits du panier : navigation classique
        e.preventDefault();
        const m = document.getElementById('menuMobile'); if (m) m.classList.remove('ouvert');
        charge(a.href);
      });
      addEventListener('popstate', e => { if (e.state && e.state.chelsy) charge(location.href, { pousse: false }); });
    }
    return { active, charge };
  })();

  /* =========================================================
     LECTEUR DE MUSIQUE — playlist jusqu'à 10 morceaux, sur tout le site
     ========================================================= */
  const Lecteur = (() => {
    const conf = C().musique || {};
    const playlist = (conf.playlist || []).filter(m => m && m.src);
    const vide = { actif: false, demarre() {}, bascule() {}, relie() {}, majTextes() {}, fermePanneau() {} };
    if (!conf.active || !playlist.length || C().editeur) return vide;

    const etat = Object.assign({ i: 0, t: 0, joue: false, coupe: false, vol: conf.volume || .45 }, lire('chelsyLecteur', {}));
    if (etat.i >= playlist.length) { etat.i = 0; etat.t = 0; }
    const audio = new Audio(); audio.preload = 'metadata';
    let erreurs = 0, ui = null, boutonsRelies = [];
    const sauve = () => ecrire('chelsyLecteur', { i: etat.i, t: audio.currentTime || 0, joue: !audio.paused, coupe: etat.coupe, vol: etat.vol });
    const temps = s => !isFinite(s) ? '0:00' : Math.floor(s / 60) + ':' + String(Math.floor(s % 60)).padStart(2, '0');

    function chargeMorceau(i, depart = 0) {
      etat.i = (i + playlist.length) % playlist.length;
      audio.src = playlist[etat.i].src;
      if (depart) audio.addEventListener('loadedmetadata', () => { try { audio.currentTime = depart; } catch (e) { /* ignore */ } }, { once: true });
      majInterface();
    }
    function fondu(vers, duree = 1800) {
      const de = audio.volume, t0 = performance.now();
      return new Promise(r => {
        const pas = now => { const k = Math.min(1, Math.max(0, (now - t0) / duree)); audio.volume = Math.min(1, Math.max(0, de + (vers - de) * k)); k < 1 ? requestAnimationFrame(pas) : r(); };
        requestAnimationFrame(pas);
      });
    }
    function joue() {
      if (!audio.src) chargeMorceau(etat.i, etat.t);
      audio.volume = 0;
      return audio.play().then(() => { etat.coupe = false; fondu(etat.vol); sauve(); }).catch(() => { majInterface(); throw new Error('bloque'); });
    }
    async function pause() { etat.coupe = true; await fondu(0, 400); audio.pause(); sauve(); }
    const suivant = () => { chargeMorceau(etat.i + 1); joue().catch(() => {}); };
    const precedent = () => { if (audio.currentTime > 4) { audio.currentTime = 0; return; } chargeMorceau(etat.i - 1); joue().catch(() => {}); };

    audio.addEventListener('ended', suivant);
    audio.addEventListener('error', () => { if (++erreurs < playlist.length) suivant(); });
    audio.addEventListener('playing', () => { erreurs = 0; });
    ['play', 'pause'].forEach(ev => audio.addEventListener(ev, majInterface));
    let derniereSauvegarde = 0;
    audio.addEventListener('timeupdate', () => {
      majProgression();
      if (Date.now() - derniereSauvegarde > 1000) { derniereSauvegarde = Date.now(); sauve(); }
    });
    addEventListener('pagehide', sauve);

    /* ----- interface ----- */
    function construit() {
      ui = document.createElement('div');
      ui.className = 'lecteur'; ui.id = 'lecteur';
      ui.innerHTML = `
        <div class="lecteur__panneau" role="dialog" aria-label="">
          <header class="lecteur__tete"><span class="lecteur__titre-playlist"></span><span class="lecteur__nb"></span>
            <button type="button" class="lecteur__fermer" data-l="fermer">${I.croix}</button></header>
          <div class="lecteur__en-cours">
            <div class="lecteur__onde" aria-hidden="true"><i></i><i></i><i></i><i></i><i></i><i></i><i></i></div>
            <p class="lecteur__etiquette"></p>
            <p class="lecteur__morceau"></p><p class="lecteur__artiste"></p>
          </div>
          <div class="lecteur__progression"><input type="range" min="0" max="1000" value="0" data-l="position" aria-label="position"><div class="lecteur__temps"><span data-l="ecoule">0:00</span><span data-l="total">0:00</span></div></div>
          <div class="lecteur__commandes">
            <button type="button" data-l="precedent">${I.precedent}</button>
            <button type="button" class="lecteur__lecture" data-l="lecture"></button>
            <button type="button" data-l="suivant">${I.suivant}</button>
          </div>
          <label class="lecteur__volume">${I.volume}<input type="range" min="0" max="100" data-l="volume"></label>
          <ol class="lecteur__liste"></ol>
          <button type="button" class="lecteur__couper" data-l="couper"></button>
        </div>
        <button type="button" class="lecteur__disque" data-l="disque" aria-expanded="false">
          <span class="lecteur__sillons" aria-hidden="true"></span>
          <span class="lecteur__barres" aria-hidden="true"><i></i><i></i><i></i><i></i></span>
        </button>`;
      document.body.appendChild(ui);
      ui.querySelector('.lecteur__liste').innerHTML = playlist.map((m, k) => `<li><button type="button" data-l="piste" data-k="${k}"><b>${String(k + 1).padStart(2, '0')}</b><span><span class="t"></span><small></small></span><i class="eq" aria-hidden="true"><i></i><i></i><i></i></i></button></li>`).join('');
      ui.querySelectorAll('.lecteur__liste li').forEach((li, k) => { li.querySelector('.t').textContent = playlist[k].titre || ''; li.querySelector('small').textContent = playlist[k].artiste || ''; });
      ui.querySelector('[data-l="volume"]').value = Math.round(etat.vol * 100);
      ui.addEventListener('click', e => {
        const b = e.target.closest('[data-l]'); if (!b) return;
        const a = b.dataset.l;
        if (a === 'disque') ui.classList.toggle('ouvert') ? b.setAttribute('aria-expanded', 'true') : b.setAttribute('aria-expanded', 'false');
        if (a === 'fermer') fermePanneau();
        if (a === 'lecture') audio.paused ? joue().catch(() => {}) : pause();
        if (a === 'suivant') suivant();
        if (a === 'precedent') precedent();
        if (a === 'piste') { chargeMorceau(+b.dataset.k); joue().catch(() => {}); }
        if (a === 'couper') audio.paused ? joue().catch(() => {}) : pause();
      });
      ui.querySelector('[data-l="position"]').addEventListener('input', e => { if (audio.duration) audio.currentTime = e.target.value / 1000 * audio.duration; });
      ui.querySelector('[data-l="volume"]').addEventListener('input', e => { etat.vol = e.target.value / 100; audio.volume = etat.vol; sauve(); });
      document.addEventListener('click', e => { if (ui.classList.contains('ouvert') && !ui.contains(e.target)) fermePanneau(); });
      majTextes();
    }
    function fermePanneau() { if (ui) { ui.classList.remove('ouvert'); ui.querySelector('[data-l="disque"]').setAttribute('aria-expanded', 'false'); } }
    function majTextes() {
      if (!ui) return;
      ui.querySelector('.lecteur__panneau').setAttribute('aria-label', txt('lecteurTitre'));
      ui.querySelector('.lecteur__titre-playlist').textContent = txt('lecteurTitre', 'La playlist Chelsy');
      ui.querySelector('.lecteur__nb').textContent = `${playlist.length} ${txt('lecteurMorceaux', 'morceaux')}`;
      ui.querySelector('.lecteur__etiquette').textContent = txt('lecteurEnCours', 'En écoute');
      ui.querySelector('[data-l="disque"]').setAttribute('aria-label', txt('lecteurOuvrir'));
      ui.querySelector('[data-l="precedent"]').setAttribute('aria-label', txt('lecteurPrecedent'));
      ui.querySelector('[data-l="suivant"]').setAttribute('aria-label', txt('lecteurSuivant'));
      ui.querySelector('[data-l="volume"]').setAttribute('aria-label', txt('lecteurVolume'));
      ui.querySelector('[data-l="fermer"]').setAttribute('aria-label', txt('fermer'));
      majInterface();
    }
    function majInterface() {
      const enLecture = !audio.paused;
      if (ui) {
        ui.classList.toggle('joue', enLecture);
        const m = playlist[etat.i];
        ui.querySelector('.lecteur__morceau').textContent = m.titre || '';
        ui.querySelector('.lecteur__artiste').textContent = m.artiste || '';
        const bl = ui.querySelector('[data-l="lecture"]');
        bl.innerHTML = enLecture ? I.pause : I.lecture;
        bl.setAttribute('aria-label', enLecture ? txt('lecteurPause') : txt('lecteurLecture'));
        ui.querySelector('[data-l="couper"]').textContent = enLecture ? txt('lecteurCouper', 'Couper la musique') : txt('lecteurRelancer', 'Relancer la musique');
        ui.querySelectorAll('.lecteur__liste li').forEach((li, k) => li.classList.toggle('actuel', k === etat.i));
      }
      boutonsRelies = boutonsRelies.filter(b => b.isConnected);
      boutonsRelies.forEach(b => b.classList.toggle('joue', enLecture));
    }
    function majProgression() {
      if (!ui || !audio.duration) return;
      ui.querySelector('[data-l="position"]').value = audio.currentTime / audio.duration * 1000;
      ui.style.setProperty('--avance', (audio.currentTime / audio.duration * 100) + '%');
      ui.querySelector('[data-l="ecoule"]').textContent = temps(audio.currentTime);
      ui.querySelector('[data-l="total"]').textContent = temps(audio.duration);
    }

    /* ----- démarrage : tout de suite si permis, sinon au premier geste ----- */
    function demarre() { if (audio.paused) { etat.coupe = false; joue().catch(() => {}); } }
    function bascule() { audio.paused ? (etat.coupe = false, joue().catch(() => {})) : pause(); }
    function relie(bouton) { boutonsRelies.push(bouton); majInterface(); }

    construit();
    chargeMorceau(etat.i, etat.t);
    const doitJouer = !etat.coupe && (etat.joue || conf.auto);
    if (doitJouer) {
      joue().catch(() => {
        const gestes = ['pointerdown', 'touchend', 'keydown'];
        const premierGeste = e => {
          if (e.target.closest && e.target.closest('.lecteur, .musique')) return; // ces boutons gèrent eux-mêmes la musique
          gestes.forEach(g => document.removeEventListener(g, premierGeste, true));
          if (!etat.coupe && audio.paused) joue().catch(() => {});
        };
        gestes.forEach(g => document.addEventListener(g, premierGeste, true));
      });
    }
    return { actif: true, demarre, bascule, relie, majTextes, fermePanneau };
  })();

  /* =========================================================
     SALON DES LANGUES — « voie lactée » : ciel étoilé, constellation, saut en hyperespace
     ========================================================= */
  const Langues = (() => {
    let ouvert = false, ciel = null;

    // ----- ciel étoilé sur canvas (voie lactée, scintillement, étoiles filantes, hyperespace) -----
    function creeCiel(canvas) {
      const ctx = canvas.getContext('2d');
      const dpr = Math.min(2, devicePixelRatio || 1);
      let L, H, etoiles = [], filantes = [], warp = 0, anim = null, centre = { x: .5, y: .5 };
      const t0 = performance.now();
      const aleat = (a, b) => a + Math.random() * (b - a);
      function peuple() {
        L = canvas.width = innerWidth * dpr; H = canvas.height = innerHeight * dpr;
        const n = Math.round((innerWidth * innerHeight) / (innerWidth < 700 ? 1500 : 1100));
        etoiles = [];
        for (let k = 0; k < n; k++) {
          // plus de la moitié des étoiles se rassemblent dans la bande de la voie lactée (diagonale)
          let x = Math.random(), y = Math.random();
          if (Math.random() < .55) {
            const u = Math.random(), ecart = (Math.random() + Math.random() + Math.random() - 1.5) * .16;
            x = u; y = .62 - u * .42 + ecart;
          }
          const brillante = Math.random() < .06;
          const teinte = Math.random();
          etoiles.push({ x, y, z: aleat(.2, 1), r: brillante ? aleat(1.3, 2.3) : aleat(.25, 1.1), p: aleat(0, 6.28), v: aleat(.6, 2.2),
            c: teinte < .18 ? [200, 210, 255] : teinte < .45 ? [255, 222, 170] : [255, 250, 240], brillante });
        }
      }
      peuple(); addEventListener('resize', peuple);
      function dessine(t) {
        const s = (t - t0) / 1000;
        ctx.clearRect(0, 0, L, H);
        const cx = centre.x * L, cy = centre.y * H;
        for (const e of etoiles) {
          const x = e.x * L, y = e.y * H;
          const tw = .55 + .45 * Math.sin(s * e.v + e.p);
          if (warp > 0) { // hyperespace : les étoiles fuient vers les bords en traînées de lumière
            const dx = x - cx, dy = y - cy, w = warp * warp * 9;
            const nx = cx + dx * (1 + w * e.z), ny = cy + dy * (1 + w * e.z);
            const px = cx + dx * (1 + Math.max(0, w - .8) * e.z), py = cy + dy * (1 + Math.max(0, w - .8) * e.z);
            ctx.strokeStyle = `rgba(${e.c[0]},${e.c[1]},${e.c[2]},${Math.min(1, .5 + warp)})`;
            ctx.lineWidth = e.r * dpr * (1 + warp * 2);
            ctx.beginPath(); ctx.moveTo(px, py); ctx.lineTo(nx, ny); ctx.stroke();
            continue;
          }
          ctx.globalAlpha = e.brillante ? .55 + .45 * tw : .25 + .6 * tw * e.z;
          ctx.fillStyle = `rgb(${e.c[0]},${e.c[1]},${e.c[2]})`;
          ctx.beginPath(); ctx.arc(x, y, e.r * dpr, 0, 6.283); ctx.fill();
          if (e.brillante) { // petite croix de lumière
            ctx.globalAlpha = .35 * tw;
            ctx.fillRect(x - e.r * 5 * dpr, y - .4 * dpr, e.r * 10 * dpr, .8 * dpr);
            ctx.fillRect(x - .4 * dpr, y - e.r * 5 * dpr, .8 * dpr, e.r * 10 * dpr);
          }
        }
        ctx.globalAlpha = 1;
        // étoiles filantes
        if (!warp && Math.random() < .012) filantes.push({ x: aleat(.1, .9) * L, y: aleat(0, .4) * H, vx: aleat(9, 15) * dpr * (Math.random() < .5 ? -1 : 1), vy: aleat(4, 7) * dpr, vie: 1 });
        filantes = filantes.filter(f => f.vie > 0);
        for (const f of filantes) {
          const g = ctx.createLinearGradient(f.x, f.y, f.x - f.vx * 9, f.y - f.vy * 9);
          g.addColorStop(0, `rgba(255,248,230,${f.vie})`); g.addColorStop(1, 'rgba(255,230,180,0)');
          ctx.strokeStyle = g; ctx.lineWidth = 1.6 * dpr;
          ctx.beginPath(); ctx.moveTo(f.x, f.y); ctx.lineTo(f.x - f.vx * 9, f.y - f.vy * 9); ctx.stroke();
          f.x += f.vx; f.y += f.vy; f.vie -= .018;
        }
        anim = requestAnimationFrame(dessine);
      }
      anim = requestAnimationFrame(dessine);
      return {
        hyperespace(x, y, duree) {
          centre = { x: x / innerWidth, y: y / innerHeight };
          const debut = performance.now();
          return new Promise(r => { const pas = now => { warp = Math.min(1, (now - debut) / duree); warp < 1 ? requestAnimationFrame(pas) : r(); }; requestAnimationFrame(pas); });
        },
        arrete() { cancelAnimationFrame(anim); removeEventListener('resize', peuple); }
      };
    }

    // ----- constellation : lignes pointillées qui relient les astres -----
    function traceConstellation(salon) {
      const svg = salon.querySelector('.astres__constellation'); if (!svg) return;
      const boite = svg.getBoundingClientRect();
      const points = [...salon.querySelectorAll('.astre__coeur')].map(c => { const r = c.getBoundingClientRect(); return [r.left + r.width / 2 - boite.left, r.top + r.height / 2 - boite.top]; });
      svg.querySelector('path').setAttribute('d', points.map((p, k) => (k ? 'L' : 'M') + p[0].toFixed(1) + ' ' + p[1].toFixed(1)).join(' '));
    }

    function ouvre(depuis) {
      const salon = document.getElementById('salonLangues'); if (!salon || ouvert) return;
      ouvert = true;
      const r = depuis ? depuis.getBoundingClientRect() : { left: innerWidth / 2, top: 40, width: 0, height: 0 };
      salon.style.setProperty('--x', (r.left + r.width / 2) + 'px');
      salon.style.setProperty('--y', (r.top + r.height / 2) + 'px');
      const titre = salon.querySelector('[data-lettres]');
      if (!titre.dataset.decoupe) {
        titre.dataset.decoupe = '1';
        let k = 0; // lettres animées une à une, regroupées par mot pour ne jamais couper un mot en deux
        titre.innerHTML = titre.textContent.trim().split(/\s+/).map(mot => `<span class="mot">${[...mot].map(c => `<span style="--k:${k++}">${c}</span>`).join('')}</span>`).join(' ');
      }
      salon.hidden = false; document.documentElement.classList.add('salon-ouvert');
      const m = document.getElementById('menuMobile'); if (m) { m.classList.remove('ouvert'); document.body.style.overflow = ''; }
      requestAnimationFrame(() => requestAnimationFrame(() => { salon.classList.add('ouvert'); traceConstellation(salon); }));
      if (!reduit) ciel = creeCiel(salon.querySelector('canvas'));
      setTimeout(() => traceConstellation(salon), 1900);
      setTimeout(() => { const a = salon.querySelector('.astre:not(.astre--actuelle)') || salon.querySelector('.astre'); if (a) a.focus({ preventScroll: true }); }, 1000);
    }
    function ferme() {
      const salon = document.getElementById('salonLangues'); if (!salon || !ouvert) return;
      salon.classList.remove('ouvert'); salon.classList.add('ferme');
      setTimeout(() => { salon.hidden = true; salon.classList.remove('ferme'); document.documentElement.classList.remove('salon-ouvert'); if (ciel) ciel.arrete(); ciel = null; ouvert = false; }, 700);
    }

    // adresse de la page actuelle dans une autre langue (/en/…, /es/…)
    function adresseDans(racineLangue) {
      const actuelle = C().racine || '';
      let chemin = location.pathname;
      if (actuelle && (chemin === actuelle || chemin.startsWith(actuelle + '/'))) chemin = chemin.slice(actuelle.length) || '/';
      return ((racineLangue || '/').replace(/\/$/, '') + (chemin === '/' ? '/' : chemin)).replace(/\/{2,}/g, '/') + location.search + location.hash;
    }
    // mémorise la langue côté Shopify (formulaire de localisation), sans recharger
    function memorise(code, cible) {
      const form = document.getElementById('formLangue');
      if (!form) return;
      const fd = new FormData(form); fd.set('language_code', code); fd.set('return_to', cible);
      fetch(form.action, { method: 'POST', body: fd, credentials: 'same-origin' }).catch(() => {});
    }

    // changement de langue : une étoile éclate et remplit l'écran, puis la page arrive dans la nouvelle langue
    async function change(code, racineLangue, salut, origine) {
      const cible = adresseDans(racineLangue);
      memorise(code, cible);
      if (C().editeur) { location.href = cible; return; }
      const voile = document.getElementById('voilePage');
      const o = origine || { x: innerWidth / 2, y: innerHeight / 2 };
      voile.querySelectorAll('.voile-page__salut, .moitie').forEach(x => x.remove());
      voile.className = 'voile-page voile-page--etoile';
      voile.style.setProperty('--sx', o.x + 'px'); voile.style.setProperty('--sy', o.y + 'px');
      voile.insertAdjacentHTML('beforeend', `<span class="voile-page__salut">${salut || ''}</span>`);
      voile.style.transition = 'none';
      voile.style.clipPath = `circle(0px at ${o.x}px ${o.y}px)`;
      voile.classList.add('actif');
      void voile.offsetWidth;
      voile.style.transition = reduit ? 'none' : 'clip-path .9s cubic-bezier(.7,0,.2,1), opacity .35s';
      voile.style.clipPath = `circle(${Math.ceil(Math.hypot(innerWidth, innerHeight))}px at ${o.x}px ${o.y}px)`;
      await attendre(reduit ? 0 : 950);
      voile.style.transition = ''; voile.style.clipPath = '';
      return Navigation.charge(cible, { mode: 'langue', salut });
    }

    // langue choisie sur le rideau d'intro : on ne découvre jamais le site — les rideaux se ferment,
    // la page se recharge derrière dans la nouvelle langue, puis les rideaux se rouvrent sur la scène
    async function changeSurRideau(bouton) {
      const intro = document.getElementById('introRideau');
      const cible = adresseDans(bouton.dataset.racine);
      memorise(bouton.dataset.introLangue, cible);
      ecrire('chelsyIntroLangue', true); ecrire('chelsyIntroFerme', true);
      if (intro) {
        intro.querySelectorAll('.intro-langue').forEach(b => b.classList.toggle('actuelle', b === bouton));
        intro.classList.add('entree');
        await attendre(reduit ? 0 : 1500);
      }
      if (C().editeur) { location.href = cible; return; }
      Navigation.charge(cible, { mode: 'intro' });
    }

    async function choisit(astre) {
      const salon = document.getElementById('salonLangues');
      if (astre.classList.contains('astre--actuelle')) { ferme(); return; }
      salon.classList.add('choix'); astre.classList.add('choisie');
      const r = astre.querySelector('.astre__coeur').getBoundingClientRect();
      const o = { x: r.left + r.width / 2, y: r.top + r.height / 2 };
      if (ciel && !reduit) await ciel.hyperespace(o.x, o.y, 900); // saut en hyperespace vers l'étoile choisie
      const c = ciel; ciel = null; ouvert = false;
      await change(astre.dataset.langue, astre.dataset.racine, astre.dataset.salut, o);
      if (c) c.arrete();
      document.documentElement.classList.remove('salon-ouvert');
    }

    document.addEventListener('click', e => {
      const o = e.target.closest('[data-ouvre-langues]'); if (o) { e.preventDefault(); ouvre(o); return; }
      if (e.target.closest('[data-ferme-langues]')) { ferme(); return; }
      const a = e.target.closest('#salonLangues .astre'); if (a) { choisit(a); return; }
      const il = e.target.closest('[data-intro-langue]'); // choix de la langue depuis le rideau d'intro
      if (il) {
        e.preventDefault();
        if (il.classList.contains('actuelle')) return;
        changeSurRideau(il);
      }
    });
    addEventListener('resize', () => { const s = document.getElementById('salonLangues'); if (s && ouvert) traceConstellation(s); });
    return { ouvre, ferme };
  })();

  /* ---------- démarrage ---------- */
  initialise(document);
  Navigation.active();
  chargePanier().catch(() => {});
})();
